import React from "react";
import {Container} from "../Home/styleHome";
import {ApresentacaoContainerTexto, ApresentacaoImagem, ImagemApresentacao,} from "./styleApresentacao";
import {Animated} from "react-animated-css";
import Logo2x from "../imagens/apple-touch-icon.png";
import dashboard from "../imagens/dashboard@2x.png";
import {Container1, Container2, ContainerHeader, Triangulo} from "../Componentes/styleComponentes";
import {Cloud, LifeBuoy,  Pocket, Users} from "react-feather";
import {ComponenteFeature} from "../Componentes/indexComponentes";

export const Apresentacao = ({empresas}) => {
    return (
        <Container id={"empresa"}>
            <ContainerHeader>
                <Container1 background={"#DEDEDE"}>
                    <ApresentacaoContainerTexto>
                        <Animated
                            animationIn="zoomInUp"
                            animationOut="zoomOutDown"
                            animationInDuration={1000}
                            animationOutDuration={1000}
                            isVisible={empresas}
                        >
                            <div style={{display: "flex"}}>
                                <div>
                                    <img
                                        src={Logo2x}
                                        height={"auto"}
                                        width={"65px"}
                                        alt={"logo wavecode"}
                                    />
                                </div>
                                <header>
                                    <span>PLATAFORMA</span>
                                    <h2>WAVECODE </h2>
                                </header>
                            </div>
                            <div>
                                <p><b>Prospect Editais, Envie Propostas e Lances Automáticos, Monitore o Chat do Pregoeiro, Acompanhe, Gerencie e Armazene nas nuvens suas licitações</b></p>
                                <p>
                                    Nossa solução é totalmente voltada para o processo licitatório, aliando diversas soluções à um alto nível de gerenciamento dos dados, tornando-a uma ferramenta única e de alto potencial produtivo.
                                </p>
                            </div>
                        </Animated>
                    </ApresentacaoContainerTexto>
                    <ApresentacaoImagem>
                        <Animated
                            animationIn="pulse"
                            animationOut="zoomOutDown"
                            animationInDuration={1000}
                            animationOutDuration={1000}
                            isVisible={empresas}
                        >
                            <img
                                src={dashboard}
                                height={"auto"}
                                width={"92%"}
                                alt={"empresas"}
                            />
                        </Animated>
                    </ApresentacaoImagem>
                </Container1>
                <Triangulo/>
                <Container2>
                    <ComponenteFeature
                        status={empresas}
                        titulo={"INFORMAÇÃO CENTRALIZADA"}
                        icone={<Pocket/>}
                        texto={
                            "Organize e gerencie suas licitações com facilidade."
                        }
                    />
                    <ComponenteFeature
                        status={empresas}
                        titulo={"ALTA PERFORMANCE"}
                        icone={<LifeBuoy/>}
                        texto={
                            "Ganhe produtividade em processos complicados e demorados."
                        }
                    />
                    <ComponenteFeature
                        status={empresas}
                        titulo={"TRABALHE EM EQUIPE"}
                        icone={<Users/>}
                        texto={
                            "Gerencie suas empresas e colaboradores."
                        }
                    />
                    <ComponenteFeature
                        status={empresas}
                        titulo={"COMPUTAÇÃO EM NUVEM"}
                        icone={<Cloud/>}
                        texto={
                            "Estamos monitorando suas licitações 24 horas por dia e 7 dias por semana."
                        }
                    />
                </Container2>
            </ContainerHeader>
        </Container>
    );
};
